import React from "react";

import { useTranslation, Trans } from "react-i18next";

import Button from '../Button'

function WhatToTrade () {

    const { t } = useTranslation();
      
    return(
        <div className="overflow-hidden relative pt-[80px] xl:pt-[160px]">
            <div className="max-w-[1220px] mx-[20px] xl:mx-auto">
               <p className="text-[30px] xl:text-[40px] italic font-[700] merriweather"><Trans>{t('trade.18')}</Trans></p>
               <div className="flex flex-col xl:flex-row justify-between mt-[20px] xl:mt-[50px]">
                    <div className="xl:w-[525px]">
                        <div className="h-[2px] bg-[#000000]"></div>
                        <p className="text-[20px] xl:text-[30px] italic font-[700] merriweather mt-[15px]"><Trans>{t('trade.19')}</Trans></p>
                        <p className="mt-[15px] xl:mt-[25px] inter text-[14px] xl:text-[16px] font-[300] xl:max-w-[487px]">{t('trade.20')}</p>
                    </div>
                    <div className="xl:w-[525px] mt-[20px] xl:mt-0">
                        <div className="h-[2px] bg-[#000000]"></div>
                        <p className="text-[20px] xl:text-[30px] italic font-[700] merriweather mt-[15px]"><Trans>{t('trade.21')}</Trans></p>
                        <p className="mt-[15px] xl:mt-[25px] inter text-[14px] xl:text-[16px] font-[300] xl:max-w-[487px]">{t('trade.22')}</p>
                    </div>
               </div>
               <div className="flex flex-col xl:flex-row justify-between mt-[20px] xl:mt-[50px]">
                    <div className="xl:w-[525px]">
                        <div className="h-[2px] bg-[#000000]"></div>
                        <p className="text-[20px] xl:text-[30px] italic font-[700] merriweather mt-[15px]"><Trans>{t('trade.23')}</Trans></p>
                        <p className="mt-[15px] xl:mt-[25px] inter text-[14px] xl:text-[16px] font-[300] xl:max-w-[487px]">{t('trade.24')}</p>
                    </div>
                    <div className="xl:w-[525px] mt-[20px] xl:mt-0">
                        <div className="h-[2px] bg-[#000000]"></div>
                        <p className="text-[20px] xl:text-[30px] italic font-[700] merriweather mt-[15px]"><Trans>{t('trade.25')}</Trans></p>
                        <p className="mt-[15px] xl:mt-[25px] inter text-[14px] xl:text-[16px] font-[300] xl:max-w-[487px]">{t('trade.26')}</p>
                    </div>
               </div>
            </div>
        </div>
    );
}

export default WhatToTrade;